import { useContext } from "react"
import TeaserStatisticsContext from "./TeaserStatisticsContext"
export const useTeaserStatistic = id => {
  const { statsVisible, statsById, request } = useContext(
    TeaserStatisticsContext
  )
  if (!id || !statsVisible) {
    return null
  }
  if (!statsById[id]) {
    request(id)
  }
  return statsById[id]
}
